<template>
    <div>
        <v-row>
            <v-col v-for="(company, index) in companies" :key="index" sm="6" md="4">
                <v-card class="d-flex flex-column pa-5 align-content-space-between flex-wrap" height="100%" min-height="100%">
                    <v-avatar tile size="150" :color="(company.logo) ? 'white' : 'primary'" class="mb-2 ml-auto mr-auto">
                        <v-img
                            v-if="company.logo"
                            :src="company.logo.url"
                            :alt="company.name"
                            contain
                            height="150"
                        ></v-img>
                        <span class="white--text headline" v-else>{{ company.name | initialName }}</span>
                    </v-avatar>
                    <v-card-title>
                        <h3 class="headline mb-2">{{ company.name }}</h3>
                    </v-card-title>
                    <v-card-text>
                        <p>{{ company.intro }}</p>
                    </v-card-text>
                    <v-card-actions class="mt-auto" style="align-self: flex-end; width: 100%;">
                        <v-btn block color="primary" dark v-on:click.prevent="detail(company)">Ver benefícios</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <detail-benefit :dialog.sync="dialog" :company="currentCompany"></detail-benefit>
    </div>
</template>

<script>
import API from '@/api'
import DetailBenefit from '@/components/benefit/Detail'

export default {
    name: 'box-benefits',
    components: {
        DetailBenefit
    },
    data () {
        return {
            companies: [],
            dialog: null,
            currentCompany: null
        }
    },
    mounted () {
        this.loadData()
    },
    watch: {
        dialog: function (val, oldVal) {
            if (!val) this.currentCompany = null
        }
    },
    methods: {
        loadData: function () {
            let endpoint = API.EndPoints.getClubs
            let params = {}
            new API(endpoint, params).request().then(response => {
                this.companies = response.body.results
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        detail (company) {
            this.currentCompany = company
        }
    }
}
</script>
